<template>
   <base-nav class="navbar-main fixed-top" type="default" effect="dark" expand>
      <a slot="brand" class="navbar-brand mr-lg-5 mt-lg-auto" href="/">
         <img :src="require('@/assets/img/logo/icon.png')" alt="logo">
      </a>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
         <div class="col-6 collapse-brand">
            <a href="index.html">
               <img :src="require('@/assets/img/logo/logo.png')">
            </a>
         </div>
         <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
         </div>
      </div>

      <ul class="navbar-nav ml-lg-auto">
         <li class="nav-item d-lg-block mx-auto">
            <a href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487" target="_blank" rel="noopener" class="btn btn-outline-warning btn-icon">
               <span class="btn-inner--icon">
                  <i class="fa fa-shopping-cart mr-2"></i>
               </span>
               <span class="nav-link-inner--text">Compre agora</span>
            </a>
         </li>
      </ul>
   </base-nav>
</template>
<script>
import BaseNav from '../components/Argon/BaseNav.vue';
import CloseButton from '../components/Argon/CloseButton.vue';

export default {
   name: 'eb-navbar',
   components: {
      BaseNav,
      CloseButton
   }
};
</script>
<style scoped lang="scss">
.navbar-brand img {
   height: 2.5rem;
}
</style>
